export const DEFAULT_VALUE = '00';
export const MAX_HOURS = 23;
export const MAX_MINUTES = 59;
